import { connect } from 'react-redux';
import { updateFavourite } from '@noths/polaris-client-user-favourites';
import getConfig from 'next/config';

import type {
  ProductImagesCarouselDispatchProps,
  ProductImagesCarouselStateProps,
} from 'src/components/organisms/ProductImagesCarousel/components/ProductImagesCarousel';
import { ProductImagesCarousel } from 'src/components/organisms/ProductImagesCarousel/components/ProductImagesCarousel';
import type {
  NextOrPreviousPayload,
  OpenModalPayload,
  SetCurrentImagePayload,
} from 'src/components/organisms/ProductImagesCarousel/types';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectFavouriteProduct } from 'src/redux/favourites/selectors';
import { selectProduct } from 'src/redux/product/selectors';
import { actions } from 'src/redux/productImagesCarousel/slice';
import type { AppThunkDispatch } from 'src/redux/store';
import type { NextConfig } from 'src/types/nextConfig';

const nextConfig = getConfig() as NextConfig;

const mapStateToProps = (state: ReduxApplicationState): ProductImagesCarouselStateProps => {
  return {
    product: selectProduct(state),
    currentImage: state.productImagesCarousel.currentImage,
    navigatedBy: state.productImagesCarousel.navigatedBy,
    favouriteProduct: selectFavouriteProduct(state),
  };
};

const mapDispatchToProps = (dispatch: AppThunkDispatch): ProductImagesCarouselDispatchProps => {
  return {
    onFavouriteClick: (productCode: number) =>
      dispatch(updateFavourite({ productCode, nextConfig })),
    onNextImage: (payload: NextOrPreviousPayload) => dispatch(actions.nextImage(payload)),
    onOpenModal: (payload: OpenModalPayload) => dispatch(actions.openModal(payload)),
    onPrevImage: (payload: NextOrPreviousPayload) => dispatch(actions.prevImage(payload)),
    setCurrentImage: (payload: SetCurrentImagePayload) =>
      dispatch(actions.setCurrentImage(payload)),
  };
};

export const ProductImagesCarouselContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProductImagesCarousel);
